module.exports = __webpack_public_path__ + "media/virtualStagingContractMedia/virtualStagingMedia1-72b4db08.jpeg";